(function(){
  'use strict';

  var scheduled = false;
  var clarityObserver = null;
  var observedClarityRoot = null;
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function setImportant(element, property, value){
    if(!element) return;
    if(
      element.style.getPropertyValue(property) === value &&
      element.style.getPropertyPriority(property) === 'important'
    ) return;
    element.style.setProperty(property, value, 'important');
  }

  function clearProperties(element, properties){
    if(!element) return;
    properties.forEach(function(property){
      element.style.removeProperty(property);
    });
  }

  function getClarityAgent(){
    var host = document.getElementById('ads-agent-host');
    if(!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('[aria-label="Shopping Agent"]');
  }

  function getClarityParts(agent){
    if(!agent) return null;
    return {
      agent:agent,
      button:agent.querySelector('[role="button"]')
    };
  }

  function isClarityOpen(parts){
    return Boolean(
      parts &&
      parts.button &&
      parts.button.getAttribute('aria-expanded') === 'true'
    );
  }

  function setClarityCompact(parts, compact){
    if(!parts || !parts.button) return;

    var textNodes = parts.button.querySelectorAll('div, span, p');
    Array.prototype.forEach.call(textNodes, function(element){
      var text = (element.textContent || '').trim();
      if(!text || element.children.length > 0) return;

      if(compact){
        setImportant(element, 'display', 'none');
        element.setAttribute('data-hitch-clarity-text', 'hidden');
      } else if(element.getAttribute('data-hitch-clarity-text') === 'hidden'){
        element.style.removeProperty('display');
        element.removeAttribute('data-hitch-clarity-text');
      }
    });

    var animatedText = parts.button.querySelectorAll(
      'div[class*="overflow-hidden"]'
    );
    Array.prototype.forEach.call(animatedText, function(element){
      if(element.querySelector('svg, img, canvas')) return;

      if(compact){
        setImportant(element, 'display', 'none');
        element.setAttribute('data-hitch-clarity-wrap', 'hidden');
      } else if(element.getAttribute('data-hitch-clarity-wrap') === 'hidden'){
        element.style.removeProperty('display');
        element.removeAttribute('data-hitch-clarity-wrap');
      }
    });

    if(compact){
      setImportant(parts.button, 'width', '52px');
      setImportant(parts.button, 'height', '52px');
      setImportant(parts.button, 'min-width', '52px');
      setImportant(parts.button, 'border-radius', '999px');
      setImportant(parts.button, 'padding', '4px');
      setImportant(parts.button, 'gap', '0');
      setImportant(parts.button, 'justify-content', 'center');
      setImportant(parts.agent, 'width', '52px');
      setImportant(parts.agent, 'max-width', '52px');
      setImportant(parts.agent, 'height', '52px');
    } else {
      clearProperties(parts.button, [
        'width',
        'height',
        'min-width',
        'border-radius',
        'padding',
        'gap',
        'justify-content'
      ]);
      clearProperties(parts.agent, ['width', 'max-width', 'height']);
    }
  }

  function placeWidget(element, right, bottom, zIndex){
    if(!element) return;
    setImportant(element, 'position', 'fixed');
    setImportant(element, 'top', 'auto');
    setImportant(element, 'left', 'auto');
    setImportant(element, 'right', right + 'px');
    setImportant(element, 'bottom', bottom + 'px');
    setImportant(element, 'margin', '0');
    setImportant(element, 'transform', 'none');
    setImportant(element, 'translate', 'none');
    setImportant(element, 'z-index', String(zIndex));
  }

  function mountGoogleWidget(google){
    var mount = document.getElementById('HitchGoogleTrustWidget');
    if(!google || !mount) return;
    if(google.parentNode !== mount) mount.appendChild(google);
    if(mount.parentNode) mount.parentNode.classList.add('is-ready');

    setImportant(google, 'position', 'relative');
    setImportant(google, 'top', 'auto');
    setImportant(google, 'left', 'auto');
    setImportant(google, 'right', 'auto');
    setImportant(google, 'bottom', 'auto');
    setImportant(google, 'margin', '0 auto');
    setImportant(google, 'z-index', '1');
  }

  function observeClarity(){
    if(!('MutationObserver' in window)) return;

    var host = document.getElementById('ads-agent-host');
    var root = host && host.shadowRoot;
    if(!root || root === observedClarityRoot) return;

    if(clarityObserver) clarityObserver.disconnect();
    observedClarityRoot = root;
    clarityObserver = new MutationObserver(scheduleArrange);
    clarityObserver.observe(root, {
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:['class', 'aria-expanded']
    });
  }

  function arrangeWidgets(){
    scheduled = false;
    observeClarity();

    var clarity = getClarityAgent();
    var clarityLauncher = document.getElementById('HitchAiLauncher');
    var google = document.getElementById(
      'google-merchantwidget-iframe-wrapper'
    );
    if(!clarity && !google) return;

    var isMobile = mobileQuery.matches;
    var right = isMobile ? 16 : 24;
    var clarityBottom = isMobile ? 96 : 92;
    var clarityParts = getClarityParts(clarity);
    var clarityOpen = isClarityOpen(clarityParts);

    setClarityCompact(
      clarityParts,
      isMobile && !clarityOpen
    );

    if(clarity){
      if(isMobile && !clarityOpen){
        setImportant(clarity, 'visibility', 'hidden');
        setImportant(clarity, 'opacity', '0');
        setImportant(clarity, 'pointer-events', 'none');
      } else if(isMobile){
        clearProperties(clarity, [
          'position',
          'top',
          'left',
          'right',
          'bottom',
          'margin',
          'transform',
          'translate',
          'z-index',
          'visibility',
          'opacity',
          'pointer-events'
        ]);
      } else {
        clearProperties(clarity, [
          'visibility',
          'opacity',
          'pointer-events'
        ]);
        placeWidget(clarity, right, clarityBottom, 9981);
      }
    }

    if(clarityLauncher){
      clarityLauncher.hidden = !isMobile || !clarityParts || clarityOpen;
    }

    if(google){
      mountGoogleWidget(google);
    }
  }

  function scheduleArrange(){
    if(scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(arrangeWidgets);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scheduleArrange, {
      once:true
    });
  } else {
    scheduleArrange();
  }

  window.addEventListener('load', scheduleArrange);
  window.addEventListener('resize', scheduleArrange, { passive:true });
  document.addEventListener('click', function(event){
    var launcher = event.target.closest
      ? event.target.closest('#HitchAiLauncher')
      : null;
    if(!launcher) return;

    var parts = getClarityParts(getClarityAgent());
    if(parts && parts.button){
      parts.button.click();
      window.setTimeout(scheduleArrange, 0);
      window.setTimeout(scheduleArrange, 250);
    }
  });

  if(mobileQuery.addEventListener){
    mobileQuery.addEventListener('change', scheduleArrange);
  } else if(mobileQuery.addListener){
    mobileQuery.addListener(scheduleArrange);
  }

  if('MutationObserver' in window){
    var observer = new MutationObserver(scheduleArrange);
    observer.observe(document.documentElement, {
      childList:true,
      subtree:true
    });
  }

  window.setTimeout(scheduleArrange, 500);
  window.setTimeout(scheduleArrange, 1500);
  window.setTimeout(scheduleArrange, 3500);
})();
